export default "__VITE_ASSET__CetyOctu__"